import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const LockIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M15.8333 9.1499H4.16667C3.24619 9.1499 2.5 9.91102 2.5 10.8499V16.7999C2.5 17.7388 3.24619 18.4999 4.16667 18.4999H15.8333C16.7538 18.4999 17.5 17.7388 17.5 16.7999V10.8499C17.5 9.91102 16.7538 9.1499 15.8333 9.1499Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.83301 9.15V5.75C5.83301 4.62283 6.27199 3.54183 7.0534 2.7448C7.8348 1.94777 8.89461 1.5 9.99967 1.5C11.1047 1.5 12.1646 1.94777 12.946 2.7448C13.7274 3.54183 14.1663 4.62283 14.1663 5.75V9.15"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
